package com.macrofocus.eflux

import js.objects.unsafeJso
import map.FillPaint
import map.Layer
import mui.material.PaletteMode
import mui.material.styles.Palette
import mui.material.styles.Theme

fun Layer.show(theme: Theme) {
    if(id == "switzerland-fill") {
        paint = unsafeJso<FillPaint> {
            if(theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) {
                fillColor = theme.asDynamic().switzerlandFill
            } else {
                fillColor = theme.asDynamic().switzerlandFill
            }
            fillOpacity = 1.0
        }
        paint.asDynamic()["fill-color-transition"] = js("{ duration: 1000, delay: 0 }")
        paint.asDynamic()["fill-opacity-transition"] = js("{ duration: 1000, delay: 0 }")
    } else {
        layout = layout ?: unsafeJso() // Ensure layout exists
        layout!!.visibility = "visible"
    }
}

fun Layer.hide(theme: Theme) {
    if(id == "switzerland-fill") {
        paint = unsafeJso<FillPaint> {
            if(theme.palette.unsafeCast<Palette>().mode == PaletteMode.light) {
                fillColor = theme.asDynamic().switzerlandFill
            } else {
                fillColor = theme.asDynamic().switzerlandFill
            }
            fillOpacity = 0.0
        }
        paint.asDynamic()["fill-color-transition"] = js("{ duration: 1000, delay: 0 }")
        paint.asDynamic()["fill-opacity-transition"] = js("{ duration: 1000, delay: 0 }")
    } else {
        layout = layout ?: unsafeJso() // Ensure layout exists
        layout!!.visibility = "none"
    }
}